import React from "react";

import { useLanguageState } from "../../../context/LanguageContext";
import { COLORS } from "../../component.constants";
import { AFTERPAY_MODAL_HOST, CLEARPAY_MODAL_HOST } from "../../gift-cards/gift-cards.constants";
import Close from "../../icons/close-icon";
import styles from "./afterpay-modal.module.scss";

interface Props {
    onClick: (event) => void;
}

const AfterpayModal: React.FC<Props> = ({ onClick }) => {
    const { localization } = useLanguageState();
    return (
        <>
            <div className={styles.overlay} />
            <div className={styles.modalContainer}>
                <div className={styles.close} onClick={onClick}>
                    <Close color={COLORS.black} />
                </div>
                <div className={styles.modal}>
                    <img
                        src={
                            localization.locale === "en-GB"
                                ? CLEARPAY_MODAL_HOST
                                : AFTERPAY_MODAL_HOST
                        }
                    />
                </div>
            </div>
        </>
    );
};

export default AfterpayModal;
